<template>
    <div>
        <div class="pay_dialog" v-if="payChoose">
            <el-dialog :modal-append-to-body="false" :close-on-click-modal="false" custom-class="payCarMusic"
                title="立即购买" :visible.sync="payDialogVisible" width="800px" :before-close="handlePayClose">
                <el-divider></el-divider>
                <div class="buy_info">
                    <div class="buy_left">
                        <div class="buy_left_title">
                            <img :src="payChoose.url" alt="">
                            <div>
                                <p>{{ payChoose.song_name }}</p>
                                <span>{{ payChoose.singer }}</span>
                            </div>
                        </div>
                        <div class="choose_box">
                            <div v-for="(item, index) in specList" :key="index" class="choose">
                                <div class='title'>{{ item.title }}</div>
                                <div class='spec'>
                                    <div class='spec-item' v-for="(its, ins) in item.list" :key="its.name1 + ins"
                                        :class="[selectSpec[item.title] === its.name ? 'active' : '', its.able || index == 0 ? '' : 'disabled']">
                                        <el-tooltip class="item" :open-delay="500" effect="dark" placement="top"
                                            v-if="its.attr_des">
                                            <div slot="content" class="item_content">
                                                {{ its.attr_des }}
                                            </div>
                                            <span
                                                @click="changeSpec(item.title, its.name, its.able, index, ins, item, its)">{{
                                                    its.name1
                                            }}</span>
                                        </el-tooltip>
                                        <span v-else
                                            @click="changeSpec(item.title, its.name, its.able, index, ins, item, its)">{{
                                            its.name1
                                    }}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- <el-button class="inquiry" plain @click="consult">咨询客服授权信息</el-button> -->
                        <div class="noChoose">
                            <span>不知道怎么选？</span>
                            <img src="../../assets/home/nochoose.png" alt="">
                            <span class="consult" @click="consult">咨询客服</span>
                        </div>
                    </div>
                    <!-- 正常弹出二维码（认证成功） -->
                    <div class="buy_right" v-if="attestation">
                        <p class="payMoney" v-if="price != 0">支付金额: <span>￥</span><span class="big">{{ formateNum(+price) }}</span>
                        </p>
                        <p v-else class="custom" @click="consult">点击此处，获取二维码询价</p>
                        <!-- <div class="pay_code" ref="qrCode">
                        </div> -->
                        <div class="qrcode" v-if="imgUrl && price != 0">
                            <div class="qrcode_border">
                                <vue-qr :text="imgUrl" :margin="0" v-if="imgUrl" :size="119" :logoSrc="logo"
                                    :logoScale="0.2">
                                </vue-qr>
                            </div>
                            <div v-if="isEwm && imgUrl" class="isEwm">
                                <i class="el-icon-circle-check"></i>
                                <p>扫码成功</p>
                            </div>
                        </div>
                        <!-- 金额为0要弹出客服的二维码 -->
                        <div v-if="price == 0">
                            <img :src="($env.VUE_APP_URL + $store.state.service)" alt="" class="qrcode"
                                style="width: 124px;height:124px">
<!--                            <div class="pay_way">-->
<!--                                <h3>联系客服</h3>-->
<!--                            </div>-->
                        </div>
                        <div class="pay_way" v-if="imgUrl && price != 0">
                            <!-- <img src="../../assets/home/Alipay 1.png" alt=""> -->
                            <img src="../../assets/home/WeChat 1.png" alt="">
                            <!-- <p>使用支付宝/微信扫一扫，轻松支付</p> -->
                            <p>使用微信扫一扫，轻松支付</p>
                        </div>
                        <el-alert v-if="imgUrl && price != 0" :closable="false"
                            title="注意：付款主体请与认证主体保持一致，将作为后续购买歌曲的授权主体，以及开具发票的抬头。" type="warning">
                        </el-alert>
                        <a href="javascript:void(0)" @click="handleTransfer" v-if="imgUrl && price != 0">若需对公转账请点击此处</a>
                    </div>
                    <!-- 用户未认证 -->
                    <div class="buy_right newBuy_Right" v-if="att_status === 0">
                        <p v-show="price > 0" class="payMoney">支付金额: <span>￥</span><span class="big">{{ formateNum(+price) }}</span> </p>
                        <div class="noApprove sflex">
                            <img src="../../assets/home/unauthorized.png" alt="">
                        </div>
                        <p class="buyNow">购买前, 您需要先完成用户认证</p>
                        <span>
                            实名认证信息将作为后续采购音乐版权的授权主体，以及开具发票的发票抬头
                        </span>
                        <el-button class="inquiry" type="primary" @click="certification(0)">去认证</el-button>

                    </div>
                    <!-- 审核中 -->
                    <div class="buy_right newBuy_Right" v-else-if="att_status == 1">
                        <p v-show="price > 0" class="payMoney">支付金额: <span>￥</span><span class="big">{{ formateNum(+price) }}</span> </p>
                        <div class="noApprove sflex">
                            <img src="../../assets/home/audit.png" alt="">
                        </div>
                        <p class="buyNow">认证审核中</p>
                        <span class="receive">
                            您好，根据您提交的认证信息。我们将在1个工作日内完成对您资料的审核，如有问题请通过扫码联系客服。
                        </span>
                        <span class="tips">您可以将喜欢的歌曲先加入收藏。在审核通过(短信通知到您)后, 前往“个人中心”进行查看、购买。</span>
                        <el-button class="inquiry" type="primary" @click="certification(1)">我知道啦</el-button>

                    </div>
                    <!-- 用户未通过 -->
                    <div class="buy_right newBuy_Right" v-else-if="att_status == 3">
                        <p v-show="price > 0" class="payMoney">支付金额: <span>￥</span><span class="big">{{ formateNum(+price) }}</span> </p>
                        <div class="noApprove sflex">
                            <img src="../../assets/home/Fail.png" alt="">
                        </div>
                        <p class="buyNow">身份认证未通过！</p>
                        <span>
                            原因：{{ applyInfo.explain }}
                        </span>
                        <el-button class="inquiry" type="primary" @click="certification(3)">修改信息再提交认证</el-button>

                    </div>
                </div>
            </el-dialog>
        </div>
        <transferVue ref="transfer" :orderDetail="orderDetail"></transferVue>
        <!-- 用户支付成功 -->
        <!-- <paySuccessVue ref="paySuccessVue"></paySuccessVue> -->
        <div class="settlement_box">
            <el-dialog :modal-append-to-body="false" custom-class="delCarMusic" :close-on-click-modal="false"
                title="用户支付" :visible.sync="paySuccess" width="540px" :before-close="handleClose">
                <div class="paySuccess">
                    <!-- <img src="../../assets/home/success.png" alt=""> -->
                    <img src="../../assets/home/success1.png" alt="">
                    <h3>支付成功！</h3>
                    <div class="btn_box">
                        <div class="btn" :loading="downLoading" @click="downLoadMusic">{{ downLoadName }}
                        </div>
                        <div class="btn" @click="apply" v-if="orderDetail.invoice_status == 0">申请发票</div>
                        <div class="btn" v-else-if="orderDetail.invoice_status == 1">待开票</div>
                        <div class="btn" @click="gain" v-if="orderDetail.empower_status == 0">获取授权书</div>
                        <div class="btn" v-else-if="orderDetail.empower_status == 1">待签发</div>
                    </div>
                    <p>说明：后续随时可在“已完成订单”中进行以上操作</p>
                </div>
            </el-dialog>
        </div>
        <applyVue ref="apply" :applyInfo="applyInfo" :orderId="orderId" @update="getOrderDetail" :flag="flag">
        </applyVue>
        <authorizationVue ref="authorization" :applyInfo="applyInfo" :orderId="orderId" @update="getOrderDetail"
            :flag="flag">
        </authorizationVue>
        <codeVue ref="code"></codeVue>
        <Tips ref="tips" :title="tipsTitle" @faClick="faClick"></Tips>
    </div>
</template>

<script>
import transferVue from './transfer.vue'
import VueQr from 'vue-qr'
import skuVue from '../home/sku.vue'
import applyVue from '@/components/dialog/apply.vue'
import authorizationVue from '@/components/dialog/authorization.vue'
import codeVue from '../dialog/code.vue'
import formateNum from '@/assets/js/money'
import Tips from './tips.vue'


export default {
    data() {
        return {
            payDialogVisible: false,
            isActive: 0,
            payList: [
                {
                    title: '授权场景:',
                    isActive: '',
                    list: []
                },
                {
                  title: '授权权益:',
                  isActive: '',
                  list: []
                },
                {
                  title: '类型:',
                  isActive: '',
                  list: []
                },
                {
                    title: '投放渠道:',
                    isActive: '',
                    list: []
                }, {
                    title: '授权时间:',
                    isActive: '',
                    list: []
                },
                {
                    title: '授权范围:',
                    isActive: '',
                    list: []
                }
            ],
            // bothPrices: [],
            cartId: 0,
            price: '暂无报价',
            twoCode: require('../../assets/home/jay.jpeg'),
            logo: '',
            imgUrl: '',
            specList: [],
            skuList: [],
            selectSpec: {},  // 选择数据的对象 将已选的数据放在这个对象里面记录下来  用对象的好处在下面深拷贝处就能体验到了
            isEwm: false,//用户未扫码
            timer: null,
            codeKey: '',//判断是否扫码的参数
            paySuccess: false,//是否支付成功,
            attestation: true,//认证是否都是弹出扫码页面
            att_status: '',//用户认证状态   0：未认证 1：审核中 2：认证成功 3：认证失败
            orderDetail: {
                status: 0
            },//订单详情
            flag: 0,
            orderId: '',
            applyInfo: {},
            historyId: '',
            AuthenticationOk: false,//认证成功
            transfer: {},//转账汇款的参数
            downLoadName: '下载歌曲',
            downLoading: false,
            downLoadTimer: null,
            scene_id: '',
            tipsTitle: '',
            arr: [],
            skuArr:{},
            check: '',
            skuMatrix: {},
            auth_info_ids: [],
        }
    },
    components: {
        transferVue,
        VueQr,
        skuVue,
        applyVue,
        authorizationVue,
        codeVue,
        Tips
    },
    props: {
        payChoose: {
            type: Object,
            default: () => { }
        },
        payPeices: {
            type: Array,
            default: () => []
        },
        bottomPay: Number,
        bothPrices: {
            type: Object,
            default: () => { }
        }
    },
    mounted() {
        // this.getCarList()
    },
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
    },
    watch: {
        // 获取歌曲拥有的价格配置
        payPeices(val) {
            this.payList = [
                {
                    title: '授权场景:',
                    isActive: '',
                    list: []
                },
                {
                  title: '授权权益:',
                  isActive: '',
                  list: []
                },
                {
                  title: '类型:',
                  isActive: '',
                  list: []
                },
                {
                    title: '投放渠道:',
                    isActive: '',
                    list: []
                }, {
                    title: '授权时间:',
                    isActive: '',
                    list: []
                },
                {
                    title: '授权范围:',
                    isActive: '',
                    list: []
                }
            ]
            this.imgUrl = ''
            this.logo = require('../../assets/home/WeChat 1.png')
            this.price = '暂无报价'
            let arr1 = []
            let arr2 = []
            let arr3 = []
            let arr4 = []
            let arr5 = []
            let arr6 = []
            val.map(i => {
                this.bothPrices.auth_scope.map(j => {
                    if (i.auth_scope_id == j.id) {
                        arr1.push(j)
                    }
                })
                this.bothPrices.auth_time.map(j => {
                    if (i.auth_time_id == j.id) {
                        arr2.push(j)
                    }
                })
                this.bothPrices.channel.map(j => {
                    if (i.channel_id == j.id) {
                        arr3.push(j)
                    }
                })
                this.bothPrices.scene.map(j => {
                    if (i.scene_id == j.id) {
                        if (this.$store.state.cateId == j.id) {
                            arr4.unshift(j)
                        } else {
                            arr4.push(j)
                        }
                    }
                })
                this.bothPrices.auth_type.map(j => {
                    if (i.auth_type == j.id) {
                        arr5.push(j)
                    }
                })
                this.bothPrices.auth_info.map(j => {
                    if (i.auth_info_id == j.id) {
                        arr6.push(j)
                    }
                })
            })
            arr1 = [...new Set(arr1)]
            arr2 = [...new Set(arr2)]
            arr3 = [...new Set(arr3)]
            arr4 = [...new Set(arr4)]
            arr5 = [...new Set(arr5)]
            arr6 = [...new Set(arr6)]
            this.payList[0].list = arr4
            this.payList[1].list = arr6
            this.payList[2].list = arr5
            this.payList[3].list = arr3
            this.payList[4].list = arr2
            this.payList[5].list = arr1
            let arr = [], tmp = []
            val.map((i, idx) => {
                tmp.push(i.scene_id, i.auth_info_id, i.auth_type, i.channel_id, i.auth_time_id, i.auth_scope_id)
                arr.push({
                    // id: idx,
                    specs: [i.scene_id, i.auth_info_id, i.auth_type, i.channel_id, i.auth_time_id, i.auth_scope_id],
                    price: i.price
                })
            })
            // return
            // 处理数据
            this.specList = this.payList
            this.skuList = arr;
            tmp = [...new Set(tmp)]
            //初始化sku矩阵列表
            tmp.map(v => {
                let a = []
                arr.map(item => {
                    if (item.specs.indexOf(v) >= 0) {
                        a.push(...item.specs)
                    }
                })
                this.skuMatrix[v] = [... new Set(a)]
            })
            // return
            // 初始化选择数据的对象
            this.specList.forEach(item => {
                this.$set(this.selectSpec, item.title, "");
            })
            // 将规格数据处理成我们视图所需要的数据类型
            this.specList = this.specList.map(item => {
                return {
                    title: item.title,
                    list: item.list.map(its => {
                        return {

                            name1: its.name + (its.description ?`（${its.description}）` : ''),
                            name: its.id,
                            // 判断是否可以选择
                            able: true, // 注释的调试看逻辑代码 false
                            attr_des: its.attr_des,

                        }
                    })
                }
            })
            this.payPeices.some(i => {
                if (i.scene_id == this.$store.state.cateId) {
                    // 价格配置默认是当前场景下面的第一个i
                    console.log(123)
                    this.selectSpec = {
                        '授权场景:': i.scene_id,
                        '授权权益:': i.auth_info_id,
                        '类型:': i.auth_type,
                        '投放渠道:': i.channel_id,
                        '授权时间:': i.auth_time_id,
                        '授权范围:': i.auth_scope_id,
                    }
                    this.scene_id = this.$store.state.cateId
                    /*let ii = 0, temp = []
                    for (let key in this.selectSpec) {
                        let ids = []
                        temp.push(this.selectSpec[key])
                        ids.push(...this.isAble(ii, this.selectSpec[key], ii >= 1 ? temp[ii-1] : 0, this.scene_id))
                        // this.arr[key] = ids
                        this.arr.push(...new Set(ids))
                        ii++
                    }

                    console.log(this.arr)*/

                    let skuArr = this.intersect(this.skuMatrix[i.scene_id],this.skuMatrix[i.auth_info_id])
                    let auth_info_ids = this.getSceneInfoIds(i.scene_id)
                    skuArr.push(...auth_info_ids)
                    skuArr = [...new Set(skuArr)]

                    this.specList.forEach(item => {
                        item.list.forEach((its, idx) => {
                            if (skuArr.indexOf(its.name) < 0) {
                                its.able = skuArr.indexOf(its.name) >= 0
                            }
                        })
                    });
                    return true
                } else {
                    this.selectSpec = {
                        '授权场景:': this.payPeices[0].scene_id,
                        '授权信息:': this.payPeices[0].auth_info_id,
                        '类型:': this.payPeices[0].auth_type,
                        '投放渠道:': this.payPeices[0].channel_id,
                        '授权时间:': this.payPeices[0].auth_time_id,
                        '授权范围:': this.payPeices[0].auth_scope_id,
                    }
                    // 默认是价格配置的第一种
                    /*this.selectSpec = {
                        '授权场景:': this.payPeices[0].scene_id,
                        '授权信息:': this.payPeices[0].auth_info_id,
                        '类型:': this.payPeices[0].auth_type,
                        '投放渠道:': this.payPeices[0].channel_id,
                        '授权时间:': this.payPeices[0].auth_time_id,
                        '授权范围:': this.payPeices[0].auth_scope_id,
                    }
                    this.scene_id = this.payPeices[0].scene_id
                    let skuArr = this.intersect(this.skuMatrix[this.scene_id],this.skuMatrix[this.payPeices[0].auth_info_id])
                    let auth_info_ids = this.getSceneInfoIds(this.scene_id)
                    skuArr.push(...auth_info_ids)
                    skuArr = [...new Set(skuArr)]

                    this.specList.forEach(item => {
                        item.list.forEach((its, idx) => {
                            if (skuArr.indexOf(its.name) < 0) {
                                its.able = skuArr.indexOf(its.name) >= 0
                            }
                        })
                    });
                    return true*/
                }
            })


        },
        selectSpec: {
            deep: true,
            handler(val) {
                console.log(val,'selectSpec');
                // return
                let str = ''
                for (let i in val) {
                    if (val[i] != '') {
                        str += val[i]
                    }
                }
                this.payPeices.some(i => {
                    let str2 = i.scene_id + "" + i.auth_info_id + i.auth_type + i.channel_id + i.auth_time_id + i.auth_scope_id
                    if (str == str2) {
                        // this.price = i.price
                        let price = 0
                        price  += (i.price * 1)
                        this.price = price
                        let priceData = {
                            s_id: this.payChoose.id,
                            type: 1,
                            p_id: i.id
                        }
                        this.$home.getAttestat().then(res1 => {
                            if (res1.code == 200) {
                                this.applyInfo = res1.data
                                if (res1.data.att_status != 2) {
                                    // 用户没有认证的状态
                                    this.att_status = res1.data.att_status
                                    // 把二维码页面隐藏（没有认证的情况）
                                    this.attestation = false
                                    clearInterval(this.timer)
                                    this.timer = null
                                    // this.AuthenticationOk = false
                                } else {
                                    // 生成二维码
                                    this.$home.qrPay(priceData).then(res => {
                                        if (res.code == 200) {
                                            // this.paySuccess = true
                                            this.transfer = priceData
                                            this.imgUrl = this.$axios.defaults.baseURL + res.data.uri
                                            this.codeKey = res.data.key
                                        }
                                    }).catch(err => {
                                        console.log(err);
                                    })
                                }
                            }
                        }).catch(err => {
                            //console.log(err);
                        })
                        return true
                    } else {
                        this.price = '暂无报价'
                        this.imgUrl = ''
                        this.codeKey = ''
                        this.transfer = {}
                    }
                })
            }
        },

        payDialogVisible(val) {
            if (!val) {
                this.isEwm = false
                clearInterval(this.timer)
                this.timer = null
                this.attestation = true
                this.att_status = ''
            }
        },
            codeKey(val) {
            // 当歌曲价格 大于0时才开启轮询
            if(this.price == '0.00') return
            // return
            if (!val) {
                this.isEwm = false
            } else {
                clearInterval(this.timer)
                this.timer = null
                let data = {
                    key: val
                }
                // 判断是否扫码
                this.timer = setInterval(() => {
                    this.$home.payStatus(data).then(res => {
                        if (res.code == 200) {
                            if (res.data.status == 1) {
                                // 扫码成功
                                this.isEwm = true
                                // 判断用户是否认证
                            }
                            // 支付成功
                            if (res.data.status == 2) {
                                this.orderId = res.data.id + ''
                                this.historyId = res.data.id + ''
                                // 获取订单id
                                this.getOrderDetail(res.data.id)
                                // 用户支付成功
                                clearInterval(this.timer)
                                this.timer = null
                                this.payDialogVisible = false
                                this.paySuccess = true
                            }
                            // 支付取消
                            if (res.data.status == 3) {
                                clearInterval(this.timer)
                                this.timer = null
                                this.isEwm = false
                                let str = ''
                                for (let i in this.selectSpec) {
                                    if (this.selectSpec[i] != '') {
                                        str += this.selectSpec[i]
                                    }
                                }
                                this.payPeices.some(i => {
                                    let str2 = i.scene_id + '' + i.channel_id + i.auth_time_id + i.auth_scope_id
                                    if (str == str2) {
                                        // this.price = i.price
                                        let price = 0
                                        price  += (i.price * 1)

                                        this.price = price
                                        let priceData = {
                                            s_id: this.payChoose.id,
                                            type: 1,
                                            p_id: i.id
                                        }
                                        this.$home.getAttestat().then(res1 => {
                                            if (res1.code == 200) {
                                                this.applyInfo = res1.data
                                                if (res1.data.att_status != 2) {
                                                    // 用户没有认证的状态
                                                    this.att_status = res1.data.att_status
                                                    // 把二维码页面隐藏（没有认证的情况）
                                                    this.attestation = false
                                                    clearInterval(this.timer)
                                                    this.timer = null
                                                    // this.AuthenticationOk = false
                                                } else {
                                                    // 生成二维码
                                                    this.$home.qrPay(priceData).then(res => {
                                                        if (res.code == 200) {
                                                            // this.paySuccess = true
                                                            this.transfer = priceData
                                                            this.imgUrl = this.$axios.defaults.baseURL + res.data.uri
                                                            this.codeKey = res.data.key
                                                        }
                                                    }).catch(err => {
                                                        console.log(err);
                                                    })
                                                }
                                            }
                                        }).catch(err => {
                                            //console.log(err);
                                        })
                                        return true
                                    } else {
                                        this.price = '暂无报价'
                                        this.imgUrl = ''
                                        this.codeKey = ''
                                        this.transfer = {}
                                    }
                                })
                            }
                        }
                    }).catch(err => {
                        // console.log(err);
                    })
                }, 1000);


            }
        }
    },
    methods: {
        formateNum,
        // 下载歌曲
        downLoadMusic(val) {
            this.downLoading = true
            this.downLoadName = '歌曲下载中'
            // return
            let data = {
                id: this.historyId
            }
            this.downLoadTimer = setInterval(() => {
                this.$home.downloadSongs(data).then(res => {
                    if (res.code == 200) {
                        clearInterval(this.downLoadTimer)
                        this.downLoadTimer = null
                        this.downLoading = false
                        this.downLoadName = '歌曲下载完成'
                        // window.open(res.data.uri)
                        let aDom = document.createElement('a');

                        aDom.style.display = 'none';

                        aDom.href = res.data.uri;

                        aDom.setAttribute('download', res.data.uri);

                        document.body.appendChild(aDom); aDom.click();

                        document.body.removeChild(aDom);
                    } else {
                    }
                }).catch(err => {
                    this.downLoadName = '歌曲下载失败'
                    this.downLoading = false
                    clearInterval(this.downLoadTimer)
                    this.downLoadTimer = null
                })
            }, 3000);
        },
        consult() {
            this.$refs.code.paySuccess = true
        },
        apply() {
            this.$home.getAttestat().then(res => {
                if (res.code == 200) {
                    this.applyInfo = res.data
                    this.flag = 1
                    this.orderId = this.historyId
                    this.$refs.apply.payDialogVisible = true
                }
            }).catch(err => {
                //console.log(err);
            })

        },
        gain() {
            this.$refs.code.paySuccess = true
            this.$refs.code.showContract = true
            this.$home.applyEmpower({order_id: this.historyId}).then(res => {
                if (res.code == 200) {
                    this.orderDetail.empower_status = 1;
                } else {
                    this.$msg('error', '提示', res.msg)
                }
            }).catch(err => {
            })

        },
        certification(val) {
            switch (val) {
                case 0:
                    this.$router.push({
                        path: '/authentication'
                    })
                    break;
                case 3:
                    this.$router.push({
                        path: '/authentication',
                        query: {
                            flag: 'revise'
                        }
                    })
                    break;
            }
            this.payDialogVisible = false
        },
        // 判断规格是否可以被选择  核心函数 key当前的规格的title   value规格值
        isAble(key, value, prev_v, scene_id) {
            // console.log(scene_id)
            let check = []
            this.skuList.map(function (item) {
                if (item.specs[0] == scene_id) {
                    // console.log(item.specs)
                    if (item.specs[key] == value) {
                        check.push(item.specs[key])
                    } else if (item.specs[key-1] == prev_v) {
                        check.push(item.specs[key])
                    }
                }
            })
            return check
        },
        intersect(nums1, nums2) {
            nums1.sort((a,b) => a-b)
            nums2.sort((a,b) => a-b)
            let res = []
            let key1 = 0, key2 = 0, index = 0
            while(key1 < nums1.length && key2 < nums2.length){
                if(nums1[key1] < nums2[key2]) key1++
                else if(nums1[key1] > nums2[key2]) key2++
                else{
                    res[index++] = nums1[key1]
                    key1++
                    key2++
                }
            }
            return res
        },
        getSceneInfoIds(scene_id) {
            let rs = []
            this.skuList.map(function (item) {
                if (item.specs[0] == scene_id) {
                    rs.push(item.specs[1])
                }
            })
            return rs
        },
        // 点击事件
        changeSpec(key, value, able, index, ins, item, its) {
            if (index == 0) {
                this.scene_id = value
            }
            if (this.selectSpec[item.title] === its.name) return
            // console.log('触发');
            if (this.selectSpec[key] === value) {
                this.selectSpec[key] = ''
            } else {
                this.selectSpec[key] = value
            }
            this.payPeices.some(i => {
                let x = i
                // delete x.id
                for (let j in x) {
                    if (index == 0) {
                        if (i[j] == its.name && i.scene_id == this.scene_id && j != 'id') {
                            // 点场景的时候退出循环
                            this.selectSpec = {
                                '授权场景:': x.scene_id,
                                '授权权益:': x.auth_info_id,
                                '类型:': x.auth_type,
                                '投放渠道:': x.channel_id,
                                '授权时间:': x.auth_time_id,
                                '授权范围:': x.auth_scope_id,
                            }
                            return true
                        }
                    } else {
                        // console.log(i[auth_info_id])
                        if (i[j] == its.name && i.scene_id == this.scene_id && i['auth_info_id'] == this.selectSpec['授权权益:'] && j != 'id') {
                            // 点场景的时候退出循环
                            this.selectSpec = {
                                '授权场景:': x.scene_id,
                                '授权权益:': x.auth_info_id,
                                '类型:': x.auth_type,
                                '投放渠道:': x.channel_id,
                                '授权时间:': x.auth_time_id,
                                '授权范围:': x.auth_scope_id,
                            }
                            return true
                        }
                    }
                }
            })
            /*let ii = 0, temp = []
            this.arr = []
            for (let key in this.selectSpec) {
                let ids = []
                temp.push(this.selectSpec[key])
                console.log(ii, this.selectSpec[key], ii >= 1 ? temp[ii-1] : 0, this.scene_id)
                ids.push(...this.isAble(ii, this.selectSpec[key], ii >= 1 ? temp[ii-1] : 0, this.scene_id))
                this.arr[key] = ids
                this.arr.push(...new Set(ids))
                ii++
            }*/

            let skuArr = this.intersect(this.skuMatrix[this.selectSpec['授权场景:']],this.skuMatrix[this.selectSpec['授权权益:']])
            let auth_info_ids = this.getSceneInfoIds(this.scene_id)
            skuArr.push(...auth_info_ids)
            skuArr = [...new Set(skuArr)]

            this.specList.forEach(item => {
                item.list.forEach((its, idx) => {
                    its.able = skuArr.indexOf(its.name) >= 0;
                })
            });
            // console.log(JSON.stringify(this.specList))
        },
        handlePayClose() {
            this.payDialogVisible = false
        },
        handleTransfer() {
            this.tipsTitle = '购买提醒'
            let prompt = localStorage.getItem('prompt') //是否需要不再提醒
            if (prompt == 1) {
                this.$refs.tips.dialogVisible = true
            } else if (prompt == 0) {
                this.faClick()
            }
        },
        faClick(val) {
            // 下单
            if (val) { // 如果是true的话就 是选择了不再提醒
                this.$home.setPrompt({ id: this.$store.state.user.id })
                localStorage.setItem('prompt', 0) //是否需要不再提醒
            }
            this.$home.placeOrder(this.transfer).then(res => {
                if (res.code == 200) {
                    let val = {
                        id: res.data.id
                    }
                    this.payDialogVisible = false
                    // 获取歌曲信息
                    this.$home.orderInfo(val).then(res1 => {
                        if (res1.code == 200) {
                            this.orderDetail = res1.data
                            this.$refs.transfer.payDialogVisible = true
                        }
                    }).catch(err => {
                        //console.log(err);
                    })
                }
            }).catch(err => {
                //console.log(err);
            })
        },
        getCarList() {
            let val = {
                type: 0
            }
            this.$home.attribute(val).then(res => {
                if (res.code == 200) {
                    this.bothPrices = res.data
                }
            }).catch(err => {
                // //console.log(err);
            })
        },
        handleClose() {
            this.paySuccess = false
        },
        // 获取订单详情
        getOrderDetail() {
            let val = {
                id: this.historyId
            }
            this.flag = 0
            // 获取歌曲信息
            this.$home.orderInfo(val).then(res => {
                if (res.code == 200) {
                    this.orderDetail = res.data
                }
            }).catch(err => {
                //console.log(err);
            })
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-divider {
    height: .5px;
    background-color: #f2f2f2;
}

.noChoose {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-top: 20px;
    margin-bottom: 30px;
    gap: 6px;

    img {
        width: 32px;
        height: 32px;
    }

    .consult {
        color: #666666;
        cursor: pointer;
    }
}

::v-deep .el-button--text {
    padding: 0;
    text-decoration: underline;
}

::v-deep .el-dialog__title {
    font-weight: 600;
}



.paySuccess {
    background: #FBFBFB;
    text-align: center;
    margin-bottom: 20px;
    opacity: 1;

    .btn_box {
        display: flex;
        gap: 12px;
    }

    .btn {
        width: 80px;
        height: 28px;
        border-radius: 3px;
        cursor: pointer;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #D92A20;
        text-align: center;
        // line-height: 28px;
        display: flex;
        align-items: center;
        margin: 0;
        border: 1px solid #D92A20;
    }

    img {
        width: 52px;
        height: 52px;
    }

    h3 {
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222222;
        line-height: 23px;
        margin: 25px 0 20px 0;
    }

    div {
        display: flex;
        margin: auto;
        justify-content: space-evenly;
        width: 260px;

        a {
            color: #D92A20;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #D92A20;
            line-height: 16px;
        }
    }

    p {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 16px;
        margin-top: 20px;
    }
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 60px;
    margin-left: 60px;
}

.pay_dialog {
    ::v-deep .el-dialog {
        max-height: 570px;
        overflow-y: auto;
    }
}

.title {
    line-height: 31px;
    min-width: 80px;
}

.spec-item {
    display: inline-block;
    margin: 0;
    border: 1px solid #eee;
    cursor: pointer;
    border-radius: 2px;
}

.spec-item span {
    border:none;
    padding: 5px 10px;
    display: inline-block;
}

.active {
    border: 1px solid #d92a20;
    background-color: white;
    color: #D92A20;
}

.disabled {
    color: #c0c4cc;
    cursor: not-allowed;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
    display: none;
}

::v-deep .el-dialog__title {
    font-weight: 600;
}

::v-deep .el-alert__content {
    padding: 0;
}

::v-deep .el-alert--warning.is-light {
    padding: 5px 10px;
    // height: 48px;
}

::v-deep .el-alert__title {
    font-size: 10px;
    color: #b0a258;
    line-height: 1;
    font-family: PingFang SC-Regular, PingFang SC;
}

.pay_dialog {

    ::v-deep .el-dialog__header {
        padding: 20px 30px;
        padding-bottom: 10px;
    }

    ::v-deep .el-dialog__body {
        margin: 0 30px;
        padding: 0;
        margin-bottom: 0;
        padding-bottom: 0;

        .el-divider--horizontal {
            margin: 0;
        }
    }

    ::v-deep .el-dialog {
        border-radius: 6px 6px 6px 6px;
        opacity: 1;

        .buy_info {
            display: flex;
            justify-content: space-between;

            .buy_left {
                height: 500px;
                overflow-y: scroll;

                .buy_left_title {
                    display: flex;
                    align-items: center;
                    margin-top: 19px;

                    img {
                        width: 41px;
                        height: 41px;
                        border-radius: 3px;
                        opacity: 1;
                        margin-right: 7px;
                    }

                    >div {
                        font-size: 14px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 1;

                        >p {
                            margin-bottom: 3px;
                        }
                    }

                }

                .choose_box {
                    padding-bottom: 24px;
                }

                .choose {
                    display: flex;
                    margin-top: 20px;

                    .spec {
                        width: 360px;
                        display: flex;
                        gap: 6px;
                        // margin-top: 3px;
                        flex-wrap: wrap;
                    }
                }

                .inquiry {
                    border-radius: 4px 4px 4px 4px;
                    opacity: 1;
                    border: 1px solid #D92A20;
                    color: #D92A20;
                    margin-top: 24px;
                }
            }

            .buy_right {
                width: 250px;
                margin-left: 30px;
                margin-top: 20px;

                .noApprove {
                    width: 66px;
                    height: 66px;
                    margin: 20px auto;
                }

                .buyNow {
                    font-size: 15px;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    width: 205px;
                    margin: auto;
                    margin-top: 12px;
                }


                >span {
                    display: block;
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    margin: 12px 0 20px 0;
                    text-align: justify;
                }

                .payMoney {
                    font-size: 14px;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    line-height: 16px;

                    span {
                        font-size: 14px;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #D92A20;
                        line-height: 16px;
                    }

                    .big {
                        font-size: 22px;
                    }
                }

                .custom {
                    color: #d92a20;
                    cursor: pointer;
                    font-size: 15px;
                }

                .qrcode {
                    position: relative;
                    max-width: 130px;
                    max-height: 130px;
                    margin: 20px 0 10px 0;

                    .qrcode_border {
                        width: 130px;
                        height: 130px;
                        background: #FFFFFF;
                        border-radius: 4px 4px 4px 4px;
                        opacity: 1;
                        border: 1px solid #D9D9D9;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .isEwm {
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        bottom: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 20px;
                        color: white;
                        background-color: rgba(0, 0, 0, .7);

                    }
                }

                .pay_way {
                    img {
                        width: 30px;
                        height: 30px;
                        margin-right: 4px;
                    }

                    p {
                        font-size: 14px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 16px;
                        margin-bottom: 8px;
                    }
                }

                a {
                    color: #D92A20;
                    display: inline-block;
                    margin-top: 15px;
                    font-size: 12px;
                }

            }

            .newBuy_Right {
                width: 250px;
                background: #F8F8F8;
                border-radius: 0px 0px 0px 0px;
                opacity: 1;
                padding: 20px 24px;
                text-align: center;
                margin: 0;
                margin-left: 30px;

                .receive {
                    margin: 10px 0;
                }

                .tips {
                    font-size: 12px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    margin: 0 0 20px 0;
                }
            }
        }
    }

}
</style>
